import type { JSX } from 'react';
import { CatalogBrowser } from '../components/catalog/CatalogBrowser';

/**
 * Product catalog page (/catalog). Thin wrapper — the entire experience
 * (search, category tree, faceted filters, sort, grid/list, pagination)
 * lives in CatalogBrowser, which is shared with the storefront homepage
 * Catalog widget (PD-14547). Page-only chrome (max-width container,
 * mobile back-strip) renders because `embedded` defaults to false.
 */
export function CatalogPage(): JSX.Element {
	return <CatalogBrowser />;
}
